import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import FilmTimes from "./FilmTimes";
import { useMediaQuery } from "react-responsive";
import { Helmet } from "react-helmet-async";
import { ContentWrapper } from "../loading/LoadingSkeleton";
import { API_URL } from "../../config";


export default function Film() {
	const { id } = useParams();
	const [film, setFilm] = useState(false);
	const [error, setError] = useState("");
	const [loading, setLoading] = useState(true);
	const [imageLoaded, setImageLoaded] = useState(false);
	const imageUpgradeDone = useRef(false);
	const isMobile = useMediaQuery({ query: "(max-width: 576px)" });

	useEffect(() => {
		const fetchData = async () => {
			try {
				// Check cache first
				const cacheKey = `kriterion-film-${id}`;
				const cacheTimeKey = `kriterion-film-${id}-time`;
				const cachedData = localStorage.getItem(cacheKey);
				const cacheTime = localStorage.getItem(cacheTimeKey);
				
				if (cachedData && cacheTime && (Date.now() - parseInt(cacheTime)) < 300000) {
					const parsed = JSON.parse(cachedData);
					setFilm(parsed);
					setLoading(false);
					return;
				}

				const response = await axios.get(`${API_URL}/api/films/${id}?populate=*`);
				
				const filmData = response.data.data;
				localStorage.setItem(cacheKey, JSON.stringify(filmData));
				localStorage.setItem(cacheTimeKey, Date.now().toString());
				
				setError("");
				setFilm(filmData);
				setLoading(false);
			} catch (e) {
				if (e.response?.status === 404) {
					setFilm(false);
					setError("Title not found");
				} else {
					setError("Something went wrong, try again later");
				}
				setLoading(false);
			}
		};

		imageUpgradeDone.current = false;
		fetchData();
		window.scrollTo(0, 0);
	}, [id]);

	return (
		<ContentWrapper isLoading={loading && !error} loadingMessage="Film wordt geladen...">
			<Helmet>
				<title>{film ? `${film.attributes.titel} - Filmtheater Kriterion` : 'Film - Filmtheater Kriterion'}</title>
				<meta name="description" content={film ? `${film.attributes.titel} (${film.attributes.jaar}) - Regie: ${film.attributes.regie}. Bekijk tijden en bestel tickets voor Filmtheater Kriterion Amsterdam.` : 'Bekijk filmdetails en tijden in Filmtheater Kriterion Amsterdam.'} />
			</Helmet>
			<div className="body-container">
				{film && (
					<div 
						className="film-content"
						style={{
							opacity: imageLoaded ? 1 : 0,
							transition: 'opacity 0.2s ease-in-out'
						}}
					>
						<img
							className='banner-image'
							src={film.attributes.still?.data?.attributes?.formats?.thumbnail?.url || film.attributes.still?.data?.attributes?.formats?.medium?.url}
							alt={"Filmstill van " + film.attributes.titel}
							loading="lazy"
							onLoad={() => {
								setImageLoaded(true);
								if (!imageUpgradeDone.current) {
									imageUpgradeDone.current = true;
									// Upgrade to medium image after load
									const mediumUrl = film.attributes.still?.data?.attributes?.formats?.medium?.url;
									if (mediumUrl) {
										const img = new Image();
										img.onload = () => {
											const bannerImg = document.querySelector('.banner-image');
											if (bannerImg) bannerImg.src = mediumUrl;
										};
										img.src = mediumUrl;
									}
								}
							}}
						/>
						<div className='film-details'>
							<h2 className='film-titel' key={film.attributes.titel}>
								{film.attributes.titel}
							</h2>
							<p className='film-subtekst'>
								{film.attributes.regie} - {film.attributes.jaar} -{" "}
								{film.attributes.speelduur} 
								{isMobile && <br />}
								{!isMobile && " - "}
								{film.attributes.gesproken} -{" "}
								{film.attributes.ondertitels}
							</p>
						</div>
						<FilmTimes slug={id} />
						{film.attributes.beschrijving && JSON.parse(film.attributes.beschrijving).blocks.map(
							(block) => (
								<p
									className='tekst'
									key={block.id}
									dangerouslySetInnerHTML={{
										__html: block.data.text,
									}}
								/>
							)
						)}
					</div>
				)}
				{error && <p className='error'>{error}</p>}
			</div>
		</ContentWrapper>
	);
}

// function isOndertitel(taal) {
// 	if (taal === "Nederlands") {
// 		return "NL";
// 	} else if (!taal || taal === "Geen"){
// 		return "Geen";
// 	} else {
// 		return taal + "e";
// 	}
// }

// function isGesproken(taal) {
// 	if (taal === "Nederlands") {
// 		return "NL";
// 	} else if (!taal){
// 		return "Niet";
// 	} else {
// 		return taal;
// 	}
// }
